import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { displayDateTime, displayDate } from '../../utils/dateTime'
import contentTypes from '../../data/contentTypes.json'

import { DEALRISK } from '../../utils/constants'

const ShowPublished = ({ published, contentTypeName, productType, showTooltip, issuingEntity, documentType }) => {
  if (contentTypeName !== 'not set') {
    var contentTypeDescription = contentTypes.filter(x=>x.label == contentTypeName).map(x=>x.description)
    var result = (contentTypeName === 'Portfolio'
      ? (
        (productType.includes(DEALRISK))
          ? <div>{'MLex DealRisk®' + '\u00A0 |\u00A0\u00A0' + 'Announcement date:\u00A0' + (displayDate(published)) + '\u00A0 |\u00A0\u00A0'}<b>Portfolio</b>{showTooltip? <span className='info-icon tooltip bottom' aria-label={contentTypeDescription}></span>: null}</div>
          : <div>{'Announcement date:\u00A0' + (displayDate(published)) + '\u00A0 |\u00A0\u00A0'}<b>Portfolio</b>{showTooltip? <span className='info-icon tooltip bottom' aria-label={contentTypeDescription}></span>: null}</div>
      )
      : ((productType.includes(DEALRISK))
        ? <div>{'MLex DealRisk®' + '\u00A0 |\u00A0\u00A0' + (contentTypeName === 'Conference' ? '' : (displayDateTime(published)) + '\u00A0 |\u00A0\u00A0' + '')}<b>{contentTypeName}</b>{showTooltip ? <span className='info-icon tooltip bottom' aria-label={contentTypeDescription}></span> : null}
        {issuingEntity ? '\u00A0 |\u00A0\u00A0' + issuingEntity : null}
        {documentType ? '\u00A0 |\u00A0\u00A0' + documentType : null}
        </div>
        : <div>{(contentTypeName === 'Conference' ? '' : (displayDateTime(published)) + '\u00A0 |\u00A0\u00A0' + '')}<b>{contentTypeName}</b>{showTooltip ? <span className='info-icon tooltip bottom' aria-label={contentTypeDescription}></span> : null}
        {issuingEntity ? '\u00A0 |\u00A0\u00A0' + issuingEntity : null}
        {documentType ? '\u00A0 |\u00A0\u00A0' + documentType : null}
        </div>
      )
    )

    return <>{result}</>
  } else {
    return <Skeleton count={1} />
  }
}

export default ShowPublished
